import { useQuery } from '@tanstack/react-query';
import { getPlayers } from '../api';
import { useT } from '../i18n';
import PageHeader from '../components/PageHeader';

export default function Players() {
  const { t } = useT();
  const q = useQuery({ queryKey: ['players'], queryFn: getPlayers });
  const players = q.data?.players ?? [];
  return (
    <>
      <PageHeader eyebrow="BB Commercial" title={t('p.title')} subtitle={t('p.sub', { n: players.length })} />
      {q.isLoading && <div className="text-dim text-sm">{t('loading')}</div>}
      {q.error && <div className="text-danger text-sm">{(q.error as Error).message}</div>}
      <ul className="card divide-y divide-ink-700">
        {players.map((p) => (
          <li key={p.id} className="flex items-center gap-3 px-4 py-3">
            <span className="w-9 h-9 rounded-full bg-ink-800 border border-ink-700 flex items-center justify-center font-semibold text-sm">{p.displayName.slice(0, 1).toUpperCase()}</span>
            <div className="min-w-0"><div className="font-medium truncate">{p.displayName}</div><div className="text-xs text-dim">@{p.username}</div></div>
            {p.role === 'admin' && <span className="pill bg-court-500/15 text-court-400 ml-auto">admin</span>}
          </li>
        ))}
      </ul>
    </>
  );
}
